/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { LinkListTrustyle, LinkListTrustyleItem } from './link-list-element'
import LinkListSpark from './link-list'
import LinkListItemSpark from './link-list-item'
import { connectEntityWithProps } from '../helpers/connect-entity'
import { useEntity, useMeta } from '../helpers/selectors'
import { contentTypeId } from '../../utils/contentful'
import { usePageForUrlEntity } from '../helpers/url'

const UrlChild = (props) => {
  const pageEntity = usePageForUrlEntity(props)
  const page = useEntity(pageEntity)

  const homePath = useMeta(['breadcrumbs', 'homePath'], '')
  const href = props.url ? (props.url[0] === '/' ? props.url : `${homePath}/${props.url}`) : ''

  const ChildElement =
    props?.listVariant === 'subcategoryNavigation' ? LinkListItemSpark : LinkListTrustyleItem

  return (
    <Choose>
      <When condition={href}>
        <ChildElement href={href}>{page?.title ?? href}</ChildElement>
      </When>
      <Otherwise>{null}</Otherwise>
    </Choose>
  )
}

const LinkListItemChild = (props) => {
  const href = useEntity(props.urlRef ?? props)?.url
  const homePath = useMeta(['breadcrumbs', 'homePath'], '')

  const ChildElement =
    props?.listVariant === 'subcategoryNavigation' ? LinkListItemSpark : LinkListTrustyleItem

  if (props?.urlRef) {
    return (
      <ChildElement {...props} href={href[0] === '/' ? href : `${homePath}/${href}`}>
        {props.title}
      </ChildElement>
    )
  }
  return (
    <ChildElement {...props} href={props.url}>
      {props.title}
    </ChildElement>
  )
}

const ConnectedLinkListChild = connectEntityWithProps()((props) => {
  const childType = contentTypeId(props)

  return (
    <Choose>
      <When condition={childType === 'url'}>
        <UrlChild {...props} />
      </When>
      <Otherwise>
        <LinkListItemChild {...props} />
      </Otherwise>
    </Choose>
  )
})

const LinkListCompound = ({ title, links = [], variant, subtitle, subtitleUrl, icon }) => {
  const LinkListElement = variant === 'subcategoryNavigation' ? LinkListSpark : LinkListTrustyle

  const LinkListFragment = (
    <LinkListElement
      title={title}
      variant={variant}
      subtitle={subtitle}
      subtitleUrl={subtitleUrl}
      icon={icon}
    >
      <For each='link' of={links} index='i'>
        <ConnectedLinkListChild listVariant={variant} entity={link} key={i} />
      </For>
    </LinkListElement>
  )

  if (variant === 'subcategoryNavigation') {
    return LinkListFragment
  }

  return <div sx={{ pt: 'sm' }}>{LinkListFragment}</div>
}

export default LinkListCompound
